import React from 'react';

import HeaderContainer from 'containers/HeaderContainer';
import ProductDetailContainer from 'containers/ProductDetailContainer';
import {Helmet} from "react-helmet";
import Footer from 'views/Footer';
import AppUtil from 'AppUtil';

class ProductDetailPage extends React.Component {
	render() {
		//for other product type, it's not displayed in the URL
		const producTypeURLStr = this.props.match.params[0] || "OTHER";
		const productType = AppUtil.findProductTypeFromURL(producTypeURLStr);

		const productId = this.props.match.params.productId;
		const name = decodeURIComponent(this.props.match.params.name);

		const pathURL = this.props.match.path;
		const query = new URLSearchParams(this.props.location.search);
		const selectedImage = query.get("sc_img");
		
		return (
				<div>
					<Helmet>
						<title>{name.toUpperCase()} - {productType.label} | Seto Canvas</title>
    					<meta name="description" content={"Purchase "+name+" "+productType.label+" and many more at SetoCanvas.com"} />
					</Helmet>
					
					<HeaderContainer turnOffSticky={true} />

					<ProductDetailContainer productId={productId} name={name} editMode={pathURL.indexOf("edit") >= 0} 
											selectedImage={selectedImage} />
					<Footer />
				</div>
			);
		
	}
}


export default ProductDetailPage;


// WEBPACK FOOTER //
// ./src/pages/ProductDetailPage.js